<template>
    <div class="login-dialog--login__content-container--text">
        <v-icon class="login-dialog--login__content-container--text__checkmark" color="primary" size="100">{{icon}}</v-icon>
        <h2 class="login-dialog--login__content-container--text__title mt-16">{{title}}</h2>
        <span class="login-dialog--login__content-container--text__subtitle">{{description}}</span>
    </div>
</template>
<script>

export default {
    name: "the-welcome",
    props: {
        title: {
            required: true,
            default: ''
        },
        description: {
            required: true,
            default: ''
        },
        icon: {
            required: false,
            default: 'fxt-check'
        }
    },
    created(){
        setTimeout( () => this.$emit('close'), 3000);
    }
};
</script>
